import React, { useState, useEffect, useCallback } from "react";
import Socket from "socket";
import _ from "lodash";

import GuessingBeforeAction from "../components/GuessingBeforeAction";
import GuessingAfterAction from "../components/GuessingAfterAction";

const TOTGuessing = ({
  word,
  roomId,
  isGuesser,
  right_words,
  skipped_words,
  currentGuesser,
  category_image,
  current_category
}) => {
  const [scorerData, setScorerData] = useState({});

  const buttonPressAction = (type) => {
    let data = {};
    switch (type) {
      case "score":
        data = {
          action: "score-tot",
          roomId,
          word
        };
        break;
      case "skip":
        data = {
          action: "skip-tot",
          roomId,
          word
        };
        break;
      default:
        break;
    }
    Socket.sendMessage(data);
  };

  const handleScoreSkip = useCallback(
    _.debounce((type) => buttonPressAction(type), 1000, {
      leading: true,
      trailing: false
    }),
    [word, roomId]
  );

  const handle_score_skip = (res) => {
    setScorerData(res);
  };

  useEffect(() => {
    return Socket.addListener("tot-skipped-scored", handle_score_skip);
  }, []);

  return _.isEmpty(scorerData) ? (
    <GuessingBeforeAction
      word={word}
      isGuesser={isGuesser}
      right_words={right_words}
      skipped_words={skipped_words}
      onScoreSkip={handleScoreSkip}
      category_image={category_image}
      currentGuesser={currentGuesser}
      current_category={current_category}
    />
  ) : (
    <GuessingAfterAction
      scorerData={scorerData}
      emptyTotMessage={() => setScorerData({})}
    />
  );
};

export default TOTGuessing;
